module.exports = __webpack_public_path__ + "static/media/icon-lock--white.32472651.svg";